import React from "react";
import { withNavBars } from "../../HOCs";
import { Request } from "./request";

class AddBlockParent extends React.Component {
    render() {
        return <Request />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(AddBlockParent,props);
